import * as React from 'react'
import { Link } from 'react-router-dom'

import { Button, ButtonGroup, Icon, Select } from '../../../components'
import { getDefaultSortFromUrl } from '../../../components/Table'
import { encodeSort } from '../../../components/Table/utils'
import { SortDirection } from '../../../types'
import { InsiderView, ManagerFundSortEnum, ManagerFundSortLabel } from '../constants'
import { useInsiderTradingRouter } from '../hooks/useInsiderTradingRouter'

interface Props {
  sort?: string
  view: InsiderView.Managers | InsiderView.Funds
}

const MANAGER_FUND_SORT_VALUES = Object.values(ManagerFundSortEnum)
const MANAGER_FUND_SORT_VALUES_AS_SORTED_COLUMNS = MANAGER_FUND_SORT_VALUES.map((id) => ({ id }))

export function ManagersFundsSortSelect({ view, sort }: Props) {
  const insiderTradingRouter = useInsiderTradingRouter<InsiderView.Managers>()
  const { column, direction } = getDefaultSortFromUrl(
    MANAGER_FUND_SORT_VALUES_AS_SORTED_COLUMNS,
    sort || `-${ManagerFundSortEnum.PortfolioValue}`
  )
  const sortedColumn = column.id
  const isSortAsc = direction === SortDirection.Ascending

  return (
    <div className="flex items-center space-x-2">
      <Select
        className="w-48"
        label={<span className="text-nowrap text-2xs text-muted">Sort by</span>}
        aria-label="Sort by"
        value={sortedColumn}
        items={MANAGER_FUND_SORT_VALUES.map((value) => ({
          value,
          label: ManagerFundSortLabel[value],
          href: insiderTradingRouter.getInsiderTradingLink({
            view,
            params: { ...insiderTradingRouter.viewParams, sort: encodeSort(value, direction), page: undefined },
          }),
          reloadDocument: true,
        }))}
      />

      <ButtonGroup hasDivider={false} hasBorder={false} className="-space-x-px">
        <Button
          as={Link}
          reloadDocument
          theme="chipOutline"
          appearance="square"
          active={isSortAsc}
          to={insiderTradingRouter.getInsiderTradingLink({
            view,
            params: {
              ...insiderTradingRouter.viewParams,
              sort: encodeSort(sortedColumn, SortDirection.Ascending),
              page: undefined,
            },
          })}
        >
          <Icon name="arrowForward" className="-rotate-90" />
        </Button>
        <Button
          as={Link}
          reloadDocument
          theme="chipOutline"
          appearance="square"
          active={!isSortAsc}
          to={insiderTradingRouter.getInsiderTradingLink({
            view,
            params: {
              ...insiderTradingRouter.viewParams,
              sort: encodeSort(sortedColumn, SortDirection.Descending),
              page: undefined,
            },
          })}
        >
          <Icon name="arrowForward" className="rotate-90" />
        </Button>
      </ButtonGroup>
    </div>
  )
}
